/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerVerticalCompatibilityWithStrategyInner
 */
export interface FreelancerVerticalCompatibilityWithStrategyInner {
    /**
     * 
     * @type {string}
     * @memberof FreelancerVerticalCompatibilityWithStrategyInner
     */
    profileInfo: FreelancerVerticalCompatibilityWithStrategyInnerProfileInfoEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerVerticalCompatibilityWithStrategyInner
     */
    compatible: boolean;
}


/**
 * @export
 */
export const FreelancerVerticalCompatibilityWithStrategyInnerProfileInfoEnum = {
    Category: 'CATEGORY'
} as const;
export type FreelancerVerticalCompatibilityWithStrategyInnerProfileInfoEnum = typeof FreelancerVerticalCompatibilityWithStrategyInnerProfileInfoEnum[keyof typeof FreelancerVerticalCompatibilityWithStrategyInnerProfileInfoEnum];


/**
 * Check if a given object implements the FreelancerVerticalCompatibilityWithStrategyInner interface.
 */
export function instanceOfFreelancerVerticalCompatibilityWithStrategyInner(value: object): value is FreelancerVerticalCompatibilityWithStrategyInner {
    if (!('profileInfo' in value) || value['profileInfo'] === undefined) return false;
    if (!('compatible' in value) || value['compatible'] === undefined) return false;
    return true;
}

export function FreelancerVerticalCompatibilityWithStrategyInnerFromJSON(json: any): FreelancerVerticalCompatibilityWithStrategyInner {
    return FreelancerVerticalCompatibilityWithStrategyInnerFromJSONTyped(json, false);
}

export function FreelancerVerticalCompatibilityWithStrategyInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerticalCompatibilityWithStrategyInner {
    if (json == null) {
        return json;
    }
    return {
        
        'profileInfo': json['profileInfo'],
        'compatible': json['compatible'],
    };
}

export function FreelancerVerticalCompatibilityWithStrategyInnerToJSON(value?: FreelancerVerticalCompatibilityWithStrategyInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileInfo': value['profileInfo'],
        'compatible': value['compatible'],
    };
}

